import type { MatomoConfig } from './types';

/**
 * Bindet Matomo ein - cookielos und ohne Wiedererkennung ueber Besuche hinweg.
 *
 * `disableCookies` und `setDoNotTrack` sind hier keine Feinheiten, sondern die
 * Bedingung dafuer, dass kein Einwilligungsbanner noetig ist: Ohne Zugriff auf
 * Endgeraeteinformationen greift Paragraf 25 TTDSG nicht.
 *
 * Die Kuerzung der IP-Adresse laesst sich von hier aus nicht erzwingen - sie ist
 * eine Einstellung der Matomo-Instanz (Administration, Datenschutz) und muss dort
 * gesetzt sein.
 */
export function startAnalytics(matomo: MatomoConfig | null): void {
  if (!matomo?.siteId) return;

  const base = matomo.url.endsWith('/') ? matomo.url : `${matomo.url}/`;
  const queue: unknown[][] = ((window as any)._paq = (window as any)._paq ?? []);

  queue.push(['disableCookies']);
  queue.push(['setDoNotTrack', true]);
  queue.push(['setTrackerUrl', `${base}matomo.php`]);
  queue.push(['setSiteId', matomo.siteId]);
  queue.push(['trackPageView']);
  queue.push(['enableLinkTracking']);

  const script = document.createElement('script');
  script.async = true;
  script.src = `${base}matomo.js`;
  document.head.appendChild(script);
}
